module.exports = __webpack_public_path__ + "img/repechage-logo-black.8fd0deb7.png";